import React from 'react';

const PowerUpIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_552_28601)">
      <path
        d="M11.9997 23.9994C18.6269 23.9994 23.9994 18.6269 23.9994 11.9997C23.9994 5.37244 18.6269 0 11.9997 0C5.37244 0 0 5.37244 0 11.9997C0 18.6269 5.37244 23.9994 11.9997 23.9994Z"
        fill="#FFCA00"
      />
      <path
        d="M10.6529 2.9725L7.10317 10.4166H11.504L7.10317 20.2617L17.9209 7.29495H12.8677L15.2498 2.9725H10.6529Z"
        fill="#13191E"
      />
      <path d="M13.8497 7.01167H13.5257L15.7136 2.9725H16.0376L13.8497 7.01167Z" fill="#13191E" />
      <path d="M7.95613 20.2617H7.58449L18.3746 7.28868H18.7456L7.95613 20.2617Z" fill="#13191E" />
    </g>
    <defs>
      <clipPath id="clip0_552_28601">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default PowerUpIcon;
